<template>
  <div id="app" class="grid grid-cols-1" v-if="isRouterAlive">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive" />

    <!-- <router-view v-if="isRouterAlive" /> -->
  </div>
</template>

<script>
import { Message, MessageBox } from "element-ui";
import { getAreaList } from "@/api/public";
export default {
  name: "App",
  data() {
    return {
      isRouterAlive: true,
    };
  },
  provide: {
    showMessage: (type, message) => {
      Message({
        showClose: true,
        message: message,
        type: type,
      });
    },
    Confirm: (message, title = "提示") => {
      return MessageBox.confirm(message, title);
    },
  },
  mounted() {
    this.getdq();
    this.$store.dispatch("checkDeviceMode");
    window.addEventListener("resize", () => {
      this.$store.dispatch("checkDeviceMode");
    });
  },
  methods: {
    async getdq() {
      const res = await getAreaList();
      console.log(res);
      if (res.code == 200) {
        this.options = res.regionData;
      }
      const replaceProperties = (data) => {
        return data.map((item) => {
          item.label = item.name;
          item.value = item.id;

          if (item.children) {
            item.children = replaceProperties(item.children);
          }

          return item;
        });
      };
      const regionData = replaceProperties(res.regionData);
      sessionStorage.setItem("regionData", JSON.stringify(regionData));
    },
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(function () {
        this.isRouterAlive = true;
      });
    },
  },
};
</script>

<style>
@import url("./assets/yby.css");

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  color: #2c3e50;
  /* margin-top: 60px; */
  height: 100%;
  width: 100%;
  /* background-color: red; */
}

html,
body {
  /* 全局背景颜色 */
  background-color: #ffffff;
  height: 100%;
  width: 100%;
}

.slide-enter-active,
.slide-leave-active {
  position: absolute;
  transition: all 0.2s ease-in-out;
  top: 42px;
}

.slide-enter-to {
  left: 0;
}

.slide-enter-from {
  left: 3%;
}

.slide-leave-to,
.slide-leave-from {
  opacity: 0;
}
</style>
